module.exports = __webpack_public_path__ + "img/afericaoPneu.22a327b6.png";